"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*
  Lite version of https://github.com/heygrady/Units
 */
var dummyFn = function dummyFn(element, value) {
  return value.match(/px$/) ? parseFloat(value) : undefined;
};

var unitToPx = function () {
  var runit = /^(-?[\d+\.\-]+)([a-z]+|%)$/i;
  if (typeof document === 'undefined') return dummyFn;

  var toPx = function toPx(elem, value) {
    var prop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'width';
    var unit = (value.match(runit) || [])[2];

    if (convert && unit in convert) {
      return parseFloat(value) * convert[unit];
    }

    if (unit === 'px') {
      return parseFloat(value);
    }

    if (unit === 'rem' || unit === 'em') {
      if (unit === 'rem') {
        elem = docElement;
      }

      var _window$getComputedSt = window.getComputedStyle(elem),
          fontSize = _window$getComputedSt.fontSize;

      return parseFloat(value) * parseFloat(fontSize);
    }

    var inlineValue = elem.style[prop];
    elem.style[prop] = value;
    var pxSize = !elem.style[prop] ? 0 : parseFloat(window.getComputedStyle(elem)[prop]);
    elem.style[prop] = inlineValue;
    return pxSize;
  };

  var testElem = document.createElement('test');
  var docElement = document.documentElement;
  var conversions = {
    "in": null,
    mm: 1 / 25.4,
    cm: 1 / 2.54,
    pt: 1 / 72,
    pc: 1 / 6
  };
  docElement.appendChild(testElem);
  var convert = Object.keys(conversions).reduce(function (accumulator, unit) {
    if (conversions[unit] === null) {
      accumulator[unit] = toPx(testElem, '1' + unit);
      return accumulator;
    }

    accumulator[unit] = conversions[unit] * accumulator["in"];
    return accumulator;
  }, {});
  docElement.removeChild(testElem);
  testElem = undefined;
  return toPx;
}();

var _default = unitToPx;
exports["default"] = _default;